import React, { useState } from "react";
import UpdateFundedSkeleton from "../../components/skeletons/UpdateFundedSkeleton";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import { FaCheck } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import { showToast, showAlert } from "../../utils/utils";
import PasswordSetModal from "../../components/modals/PasswordSetModal";
import LoginAsUser from "../../components/loginasuser/LoginAsUser";
import {
  FT_OR_NUMBER_REGEX,
  showToastType
} from "../../utils/constants/appConstants";
import {
  alertActions,
  buttonName,
  fieldValidation,
  fundedAmmount
} from "../../locales/en";
import { useDispatch, useSelector } from "react-redux";
import {
  getLoanManagementquoteThunk,
  updateFundedAmountThunk
} from "../../redux/updateFundedAmountSlice";
import { sanitizeInput } from "../../utils/utils";

export default function UpdateFundedAmount() {
  const [searchQuery, setSearchQuery] = useState("");
  const [addPasswordModal, setAddPasswordModal] = useState(false);
  const [pendingUpdate, setPendingUpdate] = useState(null);
  const [isValid, setIsValid] = useState();
  const [errors, setErrors] = useState({});
  const [isdisable, setDisable] = useState(false);
  const [issubmit, setSubmit] = useState(true);
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.fundedAmount);

  const initialState = {
    invoiceId: "",
    fundingAmount: "",
    updatedFundingAmount: ""
  };

  const [fundedamnt, setFunedAmnt] = useState(initialState);

  const onInputChange = (event) => {
    const { name, value } = event.target;

    setFunedAmnt((prevFormData) => ({
      ...prevFormData,
      [name]: sanitizeInput(value)
    }));

    setPendingUpdate({ name, value: sanitizeInput(value) });
  };

  const onInputInvoice = (event) => {
    const { value } = event.target;
    setSearchQuery(sanitizeInput(value));
  };

  const handleInvoice = async () => {
    const validPattern = FT_OR_NUMBER_REGEX;
    if (searchQuery !== "") {
      if (!validPattern.test(searchQuery) || searchQuery.trim() === "") {
        showToast(fundedAmmount.errMsg.item1, showToastType.error);
        setFunedAmnt("");
        setIsValid(null);

        return;
      }
      setDisable(true);

      const cleanSearchQuery = searchQuery.replace(/ft/gi, "");

      try {
        const response = await dispatch(
          getLoanManagementquoteThunk(cleanSearchQuery)
        ).unwrap();

        if (response.status === 200) {
          setFunedAmnt(response.data.data);
          setIsValid(true);
        }
      } catch (error) {
        if (error.status === 404) {
          setIsValid(false);
          setSubmit(true);
        }
      }
    }
  };

  const handleModalClose = () => {
    setAddPasswordModal(false);
  };

  const saveFundedAmmount = async () => {
    try {
      const payload = {
        id: fundedamnt.id,
        fundingAmount: sanitizeInput(fundedamnt.updatedFundingAmount)
      };

      await dispatch(updateFundedAmountThunk(payload)).unwrap();

      setFunedAmnt({});
      setSearchQuery("");
      setIsValid(false);
      setSubmit(false);
      setDisable(false);
    } catch {
      //handle error
    }
  };

  const validate = () => {
    const tempErrors = {};

    if (!searchQuery) {
      tempErrors.searchQuery = (
        <span className="mt-1 text-danger small d-block">
          {fieldValidation.required}
        </span>
      );
    }
    if (!fundedamnt.updatedFundingAmount) {
      tempErrors.updatedFundingAmount = (
        <span className="mt-1 text-danger small d-block">
          {fieldValidation.required}
        </span>
      );
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }

    if (!isValid) {
      return;
    }

    if (fundedamnt.updatedFundingAmount > fundedamnt.fundingAmount) {
      const result = await showAlert(
        "",
        fundedAmmount?.errMsg.item2,
        alertActions.warning,
        alertActions.Confirm,
        alertActions.Cancel
      );

      if (result.isConfirmed) {
        if (pendingUpdate) {
          await saveFundedAmmount();
          setPendingUpdate(null);
        }
        return;
      }
    } else {
      if (pendingUpdate) {
        await saveFundedAmmount();
        setPendingUpdate(null);
      }
    }
  };

  return (
    <>
      <LoginAsUser />
      <TablePagesTitle mainTitle={fundedAmmount.mainTitle} />

      <div className="row mt-4 mb-2 mx-0 ">
        <div className="col-md-12 sale-leade-form">
          {loading ? (
            <UpdateFundedSkeleton />
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="row mb-2">
                <div className="col-sm-4">
                  <div className="input-title">
                    <label htmlFor="searchQuery">{fundedAmmount.invNo}</label>
                  </div>
                </div>
                <div className="col-sm-8">
                  <div className="input-group">
                    <input
                      id="searchQuery"
                      type="text"
                      placeholder={fundedAmmount.invNo}
                      name="searchQuery"
                      onChange={onInputInvoice}
                      onBlur={handleInvoice}
                      value={searchQuery}
                    />
                    {!isValid && !isdisable && errors.searchQuery && (
                      <div className="text-danger small">
                        {errors.searchQuery}
                      </div>
                    )}
                    {isValid === true && (
                      <span className="mt-1 text-success small d-block">
                        <FaCheck /> {fundedAmmount.errMsg.item3}
                      </span>
                    )}

                    {issubmit && isValid === false && (
                      <span className="mt-1 text-danger small d-block">
                        <RxCross2 /> {fundedAmmount.errMsg.item4}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              {isValid && (
                <div className="row mb-2">
                  <div className="col-sm-4">
                    <div className="input-title">
                      <label htmlFor="fundingAmount">
                        {fundedAmmount.currentFundedAmount}
                      </label>
                    </div>
                  </div>
                  <div className="col-sm-8">
                    <div className="input-group">
                      <input
                        id="fundingAmount"
                        type="text"
                        name="fundingAmount"
                        placeholder={fundedAmmount.currentFundedAmount}
                        onChange={onInputChange}
                        value={fundedamnt?.fundingAmount || ""}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="row mb-2">
                <div className="col-sm-4">
                  <div className="input-title">
                    <label htmlFor="updatedFundingAmount">
                      {fundedAmmount.newFundedAmount}
                    </label>
                  </div>
                </div>
                <div className="col-sm-8">
                  <div className="input-group">
                    <input
                      id="updatedFundingAmount"
                      type="number"
                      placeholder={fundedAmmount.fundedAmount}
                      name="updatedFundingAmount"
                      onChange={onInputChange}
                      value={fundedamnt?.updatedFundingAmount || ""}
                    />
                    {errors.updatedFundingAmount && (
                      <div className="text-danger small">
                        {errors.updatedFundingAmount}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-sm-12  d-flex  justify-content-end">
                  <button type="submit" className="btn btn-primary">
                    {buttonName?.update}
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>

      <PasswordSetModal isOpen={addPasswordModal} toggle={handleModalClose} />
    </>
  );
}
